<div *transloco="let t">
    <h2>{{ t(reportState.titleKey) }}</h2>

    <form #form="ngForm" (submit)="submitForm(form)">

        <div class="form-row">
            <dv-search-entity
                entityToSearch="KINDERORT"
                name="kinderOrt"
                [(ngModel)]="formKinderOrt"
                [placeholder]="t('COMMON.KINDERORT.AUSWAEHLEN')"
                required/>
        </div>

        <div class="row form-row">
            <div class="col-xs-12">
                <dvlib-datepicker-textfield
                    name="gueltigAb"
                    [(ngModel)]="formGueltigAb"
                    [placeholder]="t('COMMON.GUELTIG_AB_DATUM', {datum: formGueltigAb() || defaultGueltigAb | dvLocalDateFormat})"/>
            </div>
        </div>
        <div class="row form-row">
            <div class="col-xs-12">
                <dvlib-datepicker-textfield
                    name="gueltigBis"
                    [(ngModel)]="formGueltigBis"
                    [placeholder]="t('COMMON.GUELTIG_BIS_DATUM', {datum: formGueltigBis() || defaultGueltigBis | dvLocalDateFormat})"/>
            </div>
        </div>

        @if (vereinbarungTypes().length > 1) {
            <div class="row form-row">
                <div class="col-xs-12">
                    <select
                        name="vereinbarungType"
                        class="form-control"
                        required
                        [attr.aria-label]="t('COMMON.BETREUUNGSVEREINBARUNG.TYPE.AUSWAHL')"
                        [tooltip]="t('COMMON.BETREUUNGSVEREINBARUNG.TYPE.AUSWAHL')"
                        [(ngModel)]="formConfigType">
                        <option [ngValue]="null" disabled>{{ t('COMMON.BETREUUNGSVEREINBARUNG.TYPE.AUSWAHL') }}</option>
                        @for (type of vereinbarungTypes(); track type.id) {
                            <option [ngValue]="type">{{ type.name | dvbI18n }}</option>
                        }
                    </select>
                </div>
            </div>
        }

        <dvlib-loading-button type="submit" [isLoading]="isLoading()">
            {{ t('COMMON.REPORT_GENERIEREN') }}
        </dvlib-loading-button>
    </form>
</div>
